/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import Breadcrumbs from '../Breadcrumbs';

interface Props {
  crumbs: Array<any>;
  compact: boolean;
  headerButtons?: React.ReactNode;
  settingsIcon?: React.ReactNode;
  rootText?: string;
  onGoToRoot?: () => void;
}

class SidepanelHeader extends React.Component<Props> {
  _getBreadcrumbs = (): {sourceBreadcrumbs: JSX.Element; listedBreadcrumbs: React.ReactNode} => {
    const crumbs = this.props.crumbs;
    const sliceIndex = this.props.compact ? 1 : crumbs.length - 1;
    const sourceBreadcrumbs = (
      <Breadcrumbs
        className={classNames({
          'breadcrumbs--large': this.props.compact,
          'breadcrumbs--gray': !this.props.compact,
        })}
        crumbs={crumbs.slice(0, Math.max(1, sliceIndex))}
        settingsIcon={crumbs.length <= 1 ? this.props.settingsIcon : null}
        showTrailingDivider={!this.props.compact}
      />
    );
    const listedBreadcrumbs = crumbs.length > 1 && (
      <Breadcrumbs
        className={classNames('u-tiny-spacing-top', 'u-flex-display', {
          'breadcrumbs--large': !this.props.compact,
        })}
        crumbs={crumbs.slice(sliceIndex)}
        settingsIcon={this.props.settingsIcon}
      />
    );
    return {sourceBreadcrumbs, listedBreadcrumbs};
  };

  override render(): JSX.Element {
    const {sourceBreadcrumbs, listedBreadcrumbs} = this._getBreadcrumbs();
    return (
      <div className="u-width-full">
        <div className="u-flex-display">
          <div className="u-flex-grow u-vertical-center-items">{sourceBreadcrumbs}</div>
          {this.props.headerButtons}
        </div>
        {listedBreadcrumbs}
      </div>
    );
  }
}

export default SidepanelHeader;
